import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export const AreasPanelTopWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "areas-panel-top-wrapper",
})`
  border-bottom: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};
  height: 30px;
  padding-inline: 26px 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  width: 100%;

  & > .panelTopRight {
    display: flex;
    align-items: center;
    margin-inline-start: auto;
  }
`;
